var Shopify = Shopify || {};
Shopify.money_format = document.body && document.body.dataset.moneyFormat || '£{{amount}}';

Shopify.formatMoney = function(cents, format) {

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);


  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == 0 || number == null) { return 0; }

    if(precision == 2){
      number = (number/100.0).toFixed(precision).replace('.', decimal);

      var parts   = number.split(decimal);
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;

    }
    else{

      number = number.toString();
      var dollars = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

      return dollars;
    }
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      if (typeof cents == 'string') {
        cents = cents.split('.')[0];
      }
      value = formatWithDelimiters((cents / 100), 0);
      break;
    case 'amount_with_comma_separator':
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      if (typeof cents == 'string') {
        cents = cents.split('.')[0];
      }
      value = formatWithDelimiters((cents / 100), 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      if (typeof cents == 'string') {
        cents = cents.split('.')[0];
      }
      value = formatWithDelimiters((cents / 100), 0, '.', ' ');
      break;
    case 'amount_with_apostrophe_separator':
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;
    case 'amount_with_space_separator':
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      if (typeof cents == 'string') {
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, ' ');
      break;
  }


  return formatString.replace(placeholderRegex, value);
};
